export default "__VITE_ASSET__DcMVF0$T__"